
    var riot = require('riot')
    //src: starling/src/tags/modal-import/import-preview-card-parts.html
riot.tag2('import-preview-card-parts',
  '<import-preview-card instance="{this}" each="{this.parent.getParts()}"></import-preview-card>',
  '',
  'class="preview-card_parts"', function(opts) {
"use strict";

this.field = opts.field;
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('import-preview-card-parts')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-import/import-preview-card-parts.html
// module id = 759
// module chunks = 0